import React, { useContext, useEffect, useState } from 'react';
import { Modal } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLock,
  faShieldCheck,
  faUser,
} from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { observer } from 'mobx-react-lite';
import {
  CenteredParagraph,
  ContentContainer,
  ResendCode,
  ResendCodeContainer,
  TwoFactorAuthSubtitle,
} from './styles';
import RoundIcon from '../../../components/RoundIcon';
import { LoginRequestType } from '../../../constants';
import {
  FormContentGroup,
  InputContainer,
  StyledButton,
} from '../LoginFormSection/styles';
import { UserContext } from '../../../stores';
import ErrorDisplay from '../../../components/Campaigns/CampaignOverview/SendMessageSideDrawer/SendThroughForm/ErrorDisplay';

function LoginCodeContent({ intl: { formatMessage } }) {
  const [loginCode, setLoginCode] = useState('');
  const userStore = useContext(UserContext);

  const onSubmit = () => {
    // We will attempt to login with the provided code
    userStore.loginWithCode(loginCode);
  };

  const resendLoginCode = () => {
    // We will resend the code, if the user is allowed to
    if (userStore.allowResendLoginCode) {
      userStore.resendCode();
    }
  };

  useEffect(() => {
    // The timeout is empty
    if (!userStore.loginCodeTimeout) return;

    // Automatically enable the resend button once the user is allowed to resend the code
    const allowResendCodeTimout = setTimeout(() => {
      userStore.setAttr('allowResendLoginCode', true);
    }, userStore.loginCodeTimeout.diff(moment()));

    // Cancel the timeout
    return () => {
      clearTimeout(allowResendCodeTimout);
    };
  }, [userStore.loginCodeTimeout]);

  return (
    <ContentContainer>
      <RoundIcon icon={faShieldCheck} />

      <TwoFactorAuthSubtitle>
        <FormattedMessage id="pages/Login/TwoFactorAuthenticationModal/code/description" />
      </TwoFactorAuthSubtitle>

      <FormContentGroup width="300px" centered>
        <InputContainer>
          <FontAwesomeIcon icon={faLock} />
          <input
            value={loginCode}
            onChange={(e) => setLoginCode(e.target.value)}
            id="loginCode"
            name="loginCode"
            autoComplete="loginCode"
            placeholder="Two-Factor code"
          />
        </InputContainer>

        {userStore.loginRequestErrorCode && (
          <ErrorDisplay
            errorMessage={formatMessage({
              id: `pages/Login/TwoFactorAuthenticationModal/error/${userStore.loginRequestErrorCode}`,
            })}
          />
        )}

        <ResendCodeContainer onClick={resendLoginCode}>
          {userStore.allowResendLoginCode ? (
            <FormattedMessage id="pages/Login/TwoFactorAuthenticationModal/code/resend" />
          ) : (
            <FormattedMessage id="pages/Login/TwoFactorAuthenticationModal/code/resendTimeout" />
          )}
        </ResendCodeContainer>
      </FormContentGroup>

      <StyledButton onClick={onSubmit} width="300px" centered>
        <FormattedMessage id="pages/Login/TwoFactorAuthenticationModal/code/continue" />
      </StyledButton>
    </ContentContainer>
  );
}

export default injectIntl(observer(LoginCodeContent));
